/* eslint-disable @typescript-eslint/no-explicit-any */
import { Card, Input, UploadImageCard } from "@";

interface Props {
  register: any;
  errors: any;
  setValue: any;
  getValues: any;
  isSubmitSuccessful?: boolean;
  handleUpload: (file: File, field: string) => void;
  show?: string | undefined;
}

export const ThemeInfoSection = ({
  register,
  errors,
  getValues,
  isSubmitSuccessful,
  handleUpload,
  show,
}: Props) => {
  return (
    <>
      <Card title="عنوان الثيم">
        <Input
          styles="input h-16"
          label="اسم الثيم (داخلي)"
          placeholder="مثال: ثيم الشتاء 2026"
          disabled={!!show}
          input={register("title")}
          error={errors?.title}
        />
      </Card>
      <Card isOpen={false} className="pb-0" title="الصورة المصغرة للثيم">
        <UploadImageCard
          show={!show}
          className="h-20"
          success={isSubmitSuccessful}
          src={getValues("thumbnailUrl") as string}
          error={(errors.thumbnail as { message?: string })?.message}
          upload={(file: File) => handleUpload(file, "thumbnail")}
        />
      </Card>
    </>
  );
};
